export const initExpoInquiry = (form = {}) => ({
    ...(form || {}),

    _program: form?._program || null,
    _host: form?._host || null,
    _user: form?._user || null,

    index: form?.index || null,
    // subject: form?.subject || "문의글 테스트",
    // content: form?.content || "비밀글 테스트입니다",
    subject: form?.subject || null,
    content: form?.content || null,
    reply: form?.reply || null,

    isSecrete: form?.isSecrete || false,
    isHidden: form?.isHidden || false,
});
